var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8496 1V1.5996H1.5996V7.5H7.5V5.25H8.0996V7.8027C8.0991 7.9667 7.9667 8.0991 7.8027 8.0996H1.29687C1.13284 8.0991 1.00051 7.9668 1 7.8027V1.29687C1.00051 1.13313 1.13313 1.0005 1.29687 1H3.8496ZM7.75 1C7.9418 1.00272 8.0969 1.15776 8.0996 1.3496V3.14453C8.101 3.22524 8.07 3.30296 8.0137 3.36035C7.9575 3.41792 7.8802 3.45015 7.7998 3.45019C7.7195 3.45019 7.6424 3.41778 7.5859 3.36035C7.5296 3.30296 7.4986 3.22525 7.5 3.14453V2.02343L5.1836 4.34082C5.0664 4.45787 4.8761 4.4578 4.7588 4.34082C4.6418 4.22348 4.6417 4.03316 4.7588 3.91601L7.0762 1.5996H5.9541C5.8736 1.60079 5.7965 1.56983 5.7393 1.51367C5.6818 1.45722 5.6494 1.38005 5.6494 1.2998C5.6494 1.21935 5.6817 1.14214 5.7393 1.08593C5.7965 1.02979 5.8737 0.99978 5.9541 1.00097L7.75 1Z",
    fill: "black",
    stroke: "#1A1A1A",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/Export_icon.106270c484733409e31e4851d1cb680a.svg";
export { ForwardRef as ReactComponent };